import { Mode, setCompanionMode } from "@store/homeSlice";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/store";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TextIconButton from "@components/TextIconButton";
import { setOpen } from "@store/sideBarSlice";
import { useMediaQuery } from "react-responsive";
import { ScreenSize } from "@constants/screen-size";
import { Tooltip } from "@mui/material";
import { setMessage } from "@store/snackbarSlice";

const ModeSwitch = () => {
  const mode = useSelector((state: RootState) => state.home.mode);
  const selectedPatient = useSelector(
    (state: RootState) => state.home.selectedPatient,
  );
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isSmScreen = useMediaQuery({
    query: `(max-width: ${ScreenSize.md}px)`,
  });
  const portalDisabled = Boolean(
    mode === Mode.Caregiver && selectedPatient && !selectedPatient.isActive,
  );

  const toggleCompanionMode = (): void => {
    if (portalDisabled) {
      dispatch(
        setMessage({
          content: t("patientManage.portalInactive"),
          severity: "warning",
        }),
      );
      return;
    }
    const newMode = mode === Mode.Caregiver ? Mode.Patient : Mode.Caregiver;
    dispatch(setCompanionMode(newMode));
    navigate(newMode === Mode.Patient ? "/portal" : "/");
    dispatch(setOpen(newMode !== Mode.Patient && !isSmScreen));
  };

  const button = (
    <TextIconButton
      variant="outlined"
      fullWidth={true}
      onClick={toggleCompanionMode}
      iconLeft={true}
      icon={mode === Mode.Caregiver ? HomeOutlinedIcon : SettingsOutlinedIcon}
      text={t(
        mode === Mode.Caregiver
          ? "sideBar.personalPortalButton"
          : "sideBar.manageButton",
      )}
      id={
        mode === Mode.Caregiver
          ? "patient-mode-button"
          : "manage-mode-button"
      }
      disabled={portalDisabled}
    />
  );

  if (portalDisabled) {
    return (
      <Tooltip title={t("patientManage.portalInactive")}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};

export default ModeSwitch;
